<template>
  <a-alert
    v-if="isMockIdentity"
    class="mock-identity-tips"
    type="warning"
    show-icon
  >
    <template slot="message">
      {{ $t('k_5f280f85', { arg_0: mockRtx }) }}
      <a
        class="mock-exit-link"
        @click="handleExitMock"
      >{{ $t('k_94412028') }}</a>
    </template>
  </a-alert>
</template>

<script>
import { $t } from '@/i18n';
import useMockLoginRuntimeApi from '@composables/mockLogin/useMockLoginRuntimeApi';
import { message } from '@utils/wuji-message';

export default {
  name: 'MockIdentityTips',
  data() {
    return {
      exiting: false,
    };
  },
  computed: {
    // 是否处于模拟他人身份(MockProcess)状态
    isMockIdentity() {
      return !!window.GLOBAL_INFO?.mockedBy;
    },
    // 被模拟人 rtx(模拟态下服务端已把 GLOBAL_INFO.rtx 改写为被模拟人)
    mockRtx() {
      return window.GLOBAL_INFO?.rtx || '';
    },
  },
  methods: {
    // 退出模拟身份: 复用运行态退出接口, 成功后整页刷新恢复本人身份
    async handleExitMock() {
      if (this.exiting) return;
      this.exiting = true;
      try {
        await useMockLoginRuntimeApi().mockLogout();
        window.location.reload();
      } catch (e) {
        message.error($t('k_91632073'));
        this.exiting = false;
      }
    },
  },
};
</script>
